import React from 'react';
import styled from 'styled-components';
import {DividerColor} from '../../Colors';

const Hr = styled.hr`
    border:0;
    border-top: ${({height='1px',borderStyle='solid',color=DividerColor}) => `${height} ${borderStyle} ${color}`};
`;

const Divider = ({...props}) => <Hr {...props}/>;

export default Divider;